import { Badge, BadgeProps } from '@chakra-ui/react'
import { Thread_Type_Enum } from '@gql'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { threadTypeBadge } from './threadTypeBadge'

interface Props extends Omit<BadgeProps, 'colorScheme'> {
  type: Thread_Type_Enum
}

export default function ThreadTypeBadge({ type, ...badgeProps }: Props) {
  const { t } = useTranslation()
  const { labelKey, colorScheme } = threadTypeBadge(type)

  return (
    <Badge colorScheme={colorScheme} {...badgeProps}>
      {t(labelKey)}
    </Badge>
  )
}
